
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.948 14.444c.072.385.487.67.816.459A7 7 0 108.561 6.249a5 5 0 00-3.215 9.471c.355.124.67-.229.656-.605a2.992 2.992 0 01.877-2.236L9.877 9.88l.011-.011A2.99 2.99 0 0112 9c.822 0 1.566.33 2.108.865l.015.015 2.998 2.999c.444.443.72.992.827 1.565z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.707 15.707a1 1 0 01-1.414-1.414l3-3a.997.997 0 01.704-.293h.006a.996.996 0 01.704.293l3 3a1 1 0 01-1.414 1.414L13 14.414V20a1 1 0 11-2 0v-5.586l-1.293 1.293z"}})])
          )
        }
      }
    